import React, { useEffect, useState } from "react";
import "./style.css";

const AgeGate = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [under18, setUnder18] = useState(false);

  useEffect(() => {
    const isAdult = localStorage.getItem("isAdult");
    const denied = localStorage.getItem("under18");

    if (!isAdult && !denied) {
      setShowModal(true);
    }
    if (denied) {
      setUnder18(true);
      setShowModal(true);
    }
  }, []);

  const confirm18 = () => {
    localStorage.setItem("isAdult", "true");
    setShowModal(false);
  };

  const deny18 = () => {
    localStorage.setItem("under18", "true");
    setUnder18(true);
    setShowModal(true);
  };

  return (
    <div className="age-wrapper">
      {children}

      {showModal && (
        <div className="age-modal">
          <div className="age-box">
            {!under18 ? (
              <>
                <h2>Вам уже есть 18?</h2>
                <p>Вход на сайт доступен только совершеннолетним пользователям.</p>
                <div className="buttons">
                  <button className="yes" onClick={confirm18}>
                    Да, мне уже есть 18.
                  </button>
                  <button className="no" onClick={deny18}>
                    Нет, мне меньше 18.
                  </button>
                </div>
              </>
            ) : (
              <p>
                Извините, но по законам РФ контент, связанный с нашей продукцией,
                доступен только совершеннолетним пользователям.
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AgeGate;
